/**
 * Filtro/ordenação puros para a lista de códigos promocionais do Stripe.
 * O Stripe não apaga um promotion code ao "deletar": apenas marca active=false.
 * Por isso a lista precisa ocultar inativos por padrão.
 */

/** Quantidade de promos inativos na lista. */
export function countInactivePromos(promos) {
  if (!Array.isArray(promos)) return 0;
  return promos.filter((p) => p && p.active === false).length;
}

/**
 * Lista visível: ativos primeiro, e inativos só quando showInactive=true.
 * Não muta a lista de entrada.
 */
export function filterVisiblePromos(promos, showInactive) {
  if (!Array.isArray(promos)) return [];
  const visible = showInactive ? promos.slice() : promos.filter((p) => p && p.active !== false);
  return visible.sort((a, b) => {
    const aActive = a && a.active !== false ? 0 : 1;
    const bActive = b && b.active !== false ? 0 : 1;
    return aActive - bActive;
  });
}
